import { useState } from 'react';
import { faqData } from '@/mocks/movieData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于久久影视，您可能想了解的问题都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}